module.exports = __webpack_public_path__ + "img/badge_even_sportivi.725278a8.jpg";